dmx.slideshow.transitions.fade = function(slideshow, options) {
    return new dmx.slideshow.Transition(slideshow, Object.assign({
        duration: 800,

        setup: function() {
            this.slide1 = document.createElement('div');
            this.slide1.style.setProperty('position', 'absolute');
            this.slide1.style.setProperty('width', '100%');
            this.slide1.style.setProperty('height', '100%');
            this.slide1.style.setProperty('background-size', this.width + 'px');
            this.slide1.style.setProperty('background-image', 'url("' + this.prevSlide.url + '")');

            this.slide2 = document.createElement('div');
            this.slide2.style.setProperty('position', 'absolute');
            this.slide2.style.setProperty('width', '100%');
            this.slide2.style.setProperty('height', '100%');
            this.slide2.style.setProperty('opacity', 0);
            this.slide2.style.setProperty('transition', 'opacity ' + this.options.duration + 'ms ease-in');
            this.slide2.style.setProperty('background-size', this.width + 'px');
            this.slide2.style.setProperty('background-image', 'url("' + this.nextSlide.url + '")');

            slideshow.effectsContainer.appendChild(this.slide1);
            slideshow.effectsContainer.appendChild(this.slide2);
        },

        execute: function() {
            this.slide2.addEventListener('transitionend', this.finished.bind(this));
            this.slide2.style.setProperty('opacity', 1);
            setTimeout(this.finished.bind(this), this.options.duration);
        },

        after: function() {
        }
    }, options));
};
